











import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    name: 'KWrapper',
    props: {
        fluid: {
            type: Boolean,
            default: false
        },
        'max-width': {
            type: String,
            default: '1080'
        },
    },
    setup() {
        //

        return {
            //
        }
    }
})
